import { dataAPI } from "../api"
import { WorkspaceResourceDTO } from "../models/resources"
import { IWorkspace } from "../../components/resources"
import { ODataGetResourceResponse } from "../models/api/data"

export const getWorkspace = (id: number): Promise<IWorkspace> =>
    dataAPI
        .getJSON<ODataGetResourceResponse<WorkspaceResourceDTO>>(
            `workspaces(${id})`,
        )
        .then((Workspace) => {
            const newWorkspace: IWorkspace = {
                id: Workspace.Id,
                title: Workspace.Label,
                doesExist: true,
            }

            return newWorkspace
        })
